import { render } from "./ChangePassword.vue?vue&type=template&id=0f2cf3f2&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=0f2cf3f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f2cf3f2"

export default script